import { render, staticRenderFns } from "./ArithmeticFacts.vue?vue&type=template&id=373b6d44&"
import script from "./ArithmeticFacts.vue?vue&type=script&lang=js&"
export * from "./ArithmeticFacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports